// Outils communs aux vidéos YouTube de la chaîne FFTT (page Live, calendrier).
// Titres des lives : « PRO A DAMES | J2 | GRAND-QUEVILLY vs NIMES/MONTPELLIER »

// Championnats dont les rencontres sont diffusées sur la chaîne YouTube FFTT
export const VIDEO_CHAMPIONNATS = ['proam', 'proad'];

// L'API YouTube renvoie les titres encodés (&amp;, &#39;…)
export const decodeText = (text) => {
    const textarea = document.createElement("textarea");
    textarea.innerHTML = text || '';
    return textarea.value;
}

export const parseVideoTitle = (rawTitle) => {
    const title = decodeText(rawTitle).trim();
    const parts = title.split('|').map((part) => part.trim()).filter(Boolean);
    if (parts.length < 2) {
        return { division: null, journee: null, match: title, teams: null };
    }
    const match = parts[parts.length - 1];
    // séparateur « vs » ou « - » entouré d'espaces (GRAND-QUEVILLY n'est pas coupé)
    const teams = match.split(/\s+(?:vs\.?|-)\s+/i);
    return {
        division: parts[0],
        journee: parts.length > 2 ? parts.slice(1, -1).join(' · ') : null,
        match,
        teams: teams.length === 2 ? teams : null,
    };
}

// « PRO A DAMES » -> "proad", « PRO B MESSIEURS » -> "probm"
export const getDivisionClass = (division) => {
    if (!division) return '';
    const value = division.toLowerCase().normalize('NFD').replace(/\p{Diacritic}/gu, '');
    const level = value.includes('pro a') ? 'a' : value.includes('pro b') ? 'b' : null;
    if (!level) return '';
    const women = value.includes('dame') || value.includes('femin');
    return 'pro' + level + (women ? 'd' : 'm');
}

// Mots qui ne permettent pas de distinguer deux clubs
const STOP_WORDS = new Set(['CTT', 'CLUB', 'PING', 'TENNIS', 'TABLE', 'ENT', 'ALLIANCE', 'METROPOLE', 'LES', 'DES', 'SPO', 'ASRT', 'TTACC', 'ALCL']);

// « ST-DENIS TT93 1 » -> ["DENIS", "TT93"] ; « SAINT-DENIS » -> ["DENIS"]
const getTokens = (name) => (name || '')
    .normalize('NFD').replace(/\p{Diacritic}/gu, '')
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, ' ')
    .split(' ')
    .filter((token) => token.length >= 3 && !STOP_WORDS.has(token));

// Le nom court de la vidéo (« LA ROMAGNE ») partage au moins un mot significatif
// avec le nom officiel de l'équipe (« ROMAGNE (LA) 1 »)
const sameTeam = (videoTeam, clubName) => {
    const clubTokens = getTokens(clubName);
    return getTokens(videoTeam).some((token) => clubTokens.includes(token));
}

// "25/09/2026" et "2026-09-25T17:30:00Z" -> même jour (heure locale)
const sameDay = (frDate, isoDate) => {
    if (!frDate || !isoDate) return false;
    const date = new Date(isoDate);
    if (isNaN(date.getTime())) return false;
    const [d, m, y] = frDate.split('/').map((value) => parseInt(value, 10));
    return date.getFullYear() === y && date.getMonth() + 1 === m && date.getDate() === d;
}

const PRIORITY = { live: 0, upcoming: 1, replay: 2 };

// Cherche la vidéo d'une rencontre du calendrier.
// videos : { live: [], upcoming: [], completed: [] } (réponse de getVideos.php)
// Renvoie { status: 'live' | 'upcoming' | 'replay', videoId, url, title } ou null
export const findMatchVideo = (videos, { championnat, day, teamA, teamB, date }) => {
    if (!videos || !teamA || !teamB) return null;

    const candidates = [
        ...(videos.live || []).map((video) => ({ video, status: 'live' })),
        ...(videos.upcoming || []).map((video) => ({ video, status: 'upcoming' })),
        ...(videos.completed || []).map((video) => ({ video, status: 'replay' })),
    ];

    const found = candidates.filter(({ video }) => {
        const { division, journee, teams } = parseVideoTitle(video.snippet.title);
        if (!teams || getDivisionClass(division) !== championnat) return false;

        const pairMatches = (sameTeam(teams[0], teamA) && sameTeam(teams[1], teamB))
            || (sameTeam(teams[0], teamB) && sameTeam(teams[1], teamA));
        if (!pairMatches) return false;

        // Même journée (« J2 »), ou à défaut (phases finales) même date
        const dayNumber = journee && /^J\s*(\d+)$/i.test(journee) ? parseInt(journee.replace(/\D/g, ''), 10) : null;
        if (dayNumber !== null && day) return dayNumber === day;
        const details = video.liveStreamingDetails || {};
        return sameDay(date, details.scheduledStartTime || details.actualStartTime);
    });

    if (found.length === 0) return null;
    found.sort((a, b) => PRIORITY[a.status] - PRIORITY[b.status]);
    const { video, status } = found[0];
    return {
        status,
        videoId: video.id.videoId,
        url: 'https://www.youtube.com/watch?v=' + video.id.videoId,
        title: decodeText(video.snippet.title),
    };
}
